export default class ContextEvent {
    constructor(type) {
        this.type = type;
    };
}

ContextEvent.START_GAME = "startGame";
ContextEvent.STARTUP = "startUp";
ContextEvent.PRELOAD_COMPLETE = "ContextEvent.PRELOAD_COMPLETE";
ContextEvent.DESTROY = "ContextEvent.DESTROY";